import {
    Box,
    Chip
} from '@mui/material';
import { FC } from 'react';
import { useSearchParams } from 'react-router-dom';
import { capitalizeWords, mapDisciplineToOption } from '../../../../../utils/format';
import { DISCIPLINE_OPTION } from '../../../services/enum';
import { CourseFilter, Programme } from '../../../services/type';

type Props = {
    filter: CourseFilter;
    programme: Programme;
};

const DisciplineFilter: FC<Props> = ({ filter, programme }) => {
    const [searchParam, setSearchParams] = useSearchParams();

    const disciplineOptions = Array.from(
        new Set(
            programme.reunions.flatMap((reunion) =>
                reunion.courses.map((course) => mapDisciplineToOption(course.discipline))
            )
        )
    );
    disciplineOptions.unshift(DISCIPLINE_OPTION.TROT)

    const handleclick = (value: DISCIPLINE_OPTION) => {
        const params = new URLSearchParams(searchParam);
        if (filter.discipline === value) {
            params.delete('discipline');
        } else {
            params.set('discipline', String(value));
        }
        setSearchParams(params, { replace: true });
    };


    return (
        <Box display="flex" flexWrap="wrap" gap={1}>
            {disciplineOptions.map((option) => {
                const isActive = filter.discipline === option;

                return (
                    <Chip
                        key={option}
                        component="span"
                        label={capitalizeWords(option)}
                        onClick={() => handleclick(option)}
                        sx={{
                            px: 1.5,
                            height: 32,
                            fontSize: 12,
                            fontWeight: 700,
                            letterSpacing: 0.4,
                            borderRadius: '10px',
                            cursor: 'pointer',
                            color: 'white',
                            bgcolor: isActive ? 'secondary.main' : 'primary.light',
                            boxShadow: isActive
                                ? '0 0 0 2px rgba(255,255,255,0.15)'
                                : 'none',
                            transition: 'all 0.2s ease',
                            '&:hover': {
                                bgcolor: 'secondary.main',
                                transform: 'translateY(-1px)',
                            },
                        }}
                    />
                );
            })}
        </Box>
    );

};

export default DisciplineFilter;
